var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data",style:({height: _vm.scrollBoxHeight +'px'})},[_c('van-image',{attrs:{"src":require('@/assets/images/no-data.png')}}),_c('div',{staticClass:"no-data-text"},[_vm._v(" 暂无数据 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }